import { render } from "./CadComissionamento.vue?vue&type=template&id=6ff99bd7&scoped=true"
import script from "./CadComissionamento.vue?vue&type=script&lang=js"
export * from "./CadComissionamento.vue?vue&type=script&lang=js"

import "./CadComissionamento.vue?vue&type=style&index=0&id=6ff99bd7&scoped=true&lang=css"
import "./CadComissionamento.vue?vue&type=style&index=1&id=6ff99bd7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff99bd7"]])

export default __exports__